import { Component } from "@angular/core";

@Component({
  selector: "app-replacement-claim-overview-ordered",
  templateUrl: "./replacement-claim-overview-ordered.component.html",
  styleUrls: ["./replacement-claim-overview-ordered.component.less"],
})
export class ReplacementClaimOverviewOrderedComponent {}
